<template>
    <div class="banner w100 d-flex position-relative">
      <div class="banner__text w100">
        <div class="banner__title text-medium">Не знайшов колегу чи себе? <br> В тебе ще є час це змінити</div>
        <div class="banner__description">Розповідай співробітникам про Нова пошта Гранд пікнік, <br> номінуйте один одного та збирайте найбільшу кількість балів
        </div>
        <router-link to="/#mainForm" class="button button-success banner__button text-center">Номінувати колегу</router-link>
      </div>
      <img src="./../assets/images/banners/07_1440x816.png" class="banner__img position-absolute" alt="Cat">
    </div>
</template>

<script>
export default {
  name: 'BannerCat'
}
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
  .banner {
    background: $white;
    border: 1px solid $border-gray;
    border-radius: sm(24);
    padding: sm(40) sm(25) sm(234);
    min-height: sm(466);
    margin-bottom: sm(88);
    @include _1024 {
      border-radius: sl(24);
      padding: sl(64);
      min-height: sl(400);
      margin-bottom: sl(128);
    }
    @include _1920 {
      padding: 64px;
      min-height: 400px;
      margin-bottom: 128px;
      border-radius: 24px;
    }

    &__title {
      font-size: sm(18);
      line-height: math.div(38.4, 32);
      padding-bottom: sm(16);
      @include _1024 {
        font-size: sl(32);
        padding-bottom: sl(24);
      }
      @include _1920 {
        font-size: 32px;
        padding-bottom: 24px;
      }
    }
    &__description {
      font-size: sm(14);
      line-height: math.div(33.6, 24);
      padding-bottom: sm(24);
      @include _1024 {
        font-size: sl(24);
        padding-bottom: sl(32);
      }
      @include _1920 {
        font-size: 24px;
        padding-bottom: 32px;
      }
    }
    &__img {
      width: sm(284);
      height: sm(170);
      object-fit: contain;
      object-position: center;
      bottom: sm(32);
      right: sm(46);
      @include _1024 {
        bottom: sl(14);
        right: sl(125);
        width: sl(503);
        height: sl(302);
      }
      @include _1920 {
        width: 503px;
        height: 302px;
        bottom: 14px;
        right: 125px;
      }
    }
    &__button {
      padding: sm(14) sl(32);
      line-height: 1;
      font-size: sm(14);
      border-radius: sm(8);
      display: block;
      @include _1024 {
        padding: sl(24) sl(32);
        font-size: sl(24);
        border-radius: sl(8);
        display: inline-block;
      }
      @include _1920 {
        padding: 24px 32px;
        font-size: 24px;
        border-radius: 8px;
      }
    }
  }
</style>
